import React from 'react';

import { anelDeFoco, styledDs as styled } from '../../../styles/theme';

export type DsTextFieldProps = {
  label: string;
  error?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;

  label {
    font-size: ${({ theme }) => theme.font.sizeSm};
    font-weight: ${({ theme }) => theme.weight.semibold};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  input {
    height: 36px;
    border-radius: ${({ theme }) => theme.radius.md};
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.page};
    color: ${({ theme }) => theme.colors.textPrimary};
    padding: 0 12px;
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.sizeMd};
  }

  input:focus {
    ${anelDeFoco('-1px')}
  }

  input[aria-invalid='true'] {
    border-color: ${({ theme }) => theme.colors.statusCritical};
  }
`;

const ErrorText = styled.span`
  font-size: ${({ theme }) => theme.font.sizeSm};
  color: ${({ theme }) => theme.colors.statusCritical};
`;

export const DsTextField: React.FC<DsTextFieldProps> = ({ label, error, id, name, ...rest }) => {
  const fieldId = id || `field-${name}`;

  return (
    <Field>
      <label htmlFor={fieldId}>{label}</label>
      <input id={fieldId} name={name} aria-invalid={!!error} {...rest} />
      {error && <ErrorText role="alert">{error}</ErrorText>}
    </Field>
  );
};
